import DetailedItemCard from './DetailedItemCard'

export default DetailedItemCard